import { useRouter } from 'next/router';
import { FC, useCallback, type ReactNode } from 'react';
import { isGmbNextPath } from 'src/common/utils/routing';
import getClassNames from '../../utils/getClassNames';
import ActionsDropdown from '../ActionsDropdown';
import type { DropdownOption } from '../DropdownDS22';
import IconDS22, { IconIds } from '../IconDS22';
import style from './Navigation.module.scss';

type NavItemDropdownProps = {
  children: ReactNode;
  classNameModifier?: string;
  icon?: IconIds;
  options: DropdownOption[];
};

const NavItemDropdown: FC<NavItemDropdownProps> = ({
  children,
  classNameModifier = '',
  icon,
  options,
}) => {
  const { push } = useRouter();
  const content = (
    <>
      {icon && (
        <IconDS22
          id={icon}
          size="l"
          className={getClassNames(style, 'icon', classNameModifier)}
        />
      )}
      <span className={getClassNames(style, 'children', classNameModifier)}>
        {children}
      </span>
    </>
  );

  const handleDropdownItemSelect = useCallback(({ id = '' }: DropdownOption) => {
    if (isGmbNextPath(id)) {
      push(id);
    }
  }, [push]);

  return (
    <ActionsDropdown
      dropdownPosition="right"
      label={content}
      handleSelect={handleDropdownItemSelect}
      options={options}
      showCaret={false}
      variant="topNav"
    />
  );
};

export default NavItemDropdown;
